/*! Copyright 2026 Fonticons, Inc. - https://webawesome.com/license */

// _bundle_/src/internal/size.ts
var DEPRECATION_MAP = {
  small: "s",
  medium: "m",
  large: "l"
};
function normalizeSize(size) {
  return DEPRECATION_MAP[size] ?? size;
}
var warned = /* @__PURE__ */ new Set();
function warnDeprecatedSize(tagName, value) {
  if (value in DEPRECATION_MAP && !warned.has(`${tagName}:${value}`)) {
    warned.add(`${tagName}:${value}`);
    console.warn(
      `[${tagName}] size="${value}" is deprecated. Use size="${DEPRECATION_MAP[value]}" instead. The long-form value will be removed in the next major version.`
    );
  }
}

export {
  normalizeSize,
  warnDeprecatedSize
};
